import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08cace68&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./index.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./index.vue?vue&type=style&index=0&id=08cace68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cace68",
  null
  
)

export default component.exports